import type { WorklistSample } from './types';

export const WORKLIST_MESSAGES = {
  CLAIM_FAILED: 'This sample is no longer available in the pool.',
} as const;

export const STATUS_LABELS: Record<WorklistSample['status'], string> = {
  open: 'open',
  in_progress: 'in progress',
  rework: 'rework',
  classified: 'classified',
};

export const STATUS_COLORS: Record<WorklistSample['status'], string> = {
  open: 'default',
  in_progress: 'blue',
  rework: 'red',
  classified: 'green',
};
